import { useFormikContext } from 'formik';
import React from 'react';
import { FaTrash } from 'react-icons/fa';
import { MdAdd, MdClear } from 'react-icons/md';
import {
  AVOverviewItemTypeName,
  Button,
  ButtonVariant,
  type IAVOverviewTemplateModel,
  Row,
} from 'tno-core';

import { defaultAVOverviewTemplateSectionItem } from './constants';
import { EditBroadcastDetails } from './EditBroadcastDetails';
import { OverviewGrid } from './OverviewGrid';
import * as styled from './styled';

export interface IOverviewSectionProps {
  index: number;
}

/** This section includes the overview grid, as well as the broadcast details. */
export const OverviewSection: React.FC<IOverviewSectionProps> = ({ index }) => {
  const { values, setFieldValue } = useFormikContext<IAVOverviewTemplateModel>();

  const section = values.sections[index];

  const handleDeleteSection = (index: number) => {
    values.sections.splice(index, 1);
    setFieldValue('sections', values.sections);
  };

  const handleAddItem = (index: number) => {
    setFieldValue(`sections.${index}.items`, [
      ...section.items,
      defaultAVOverviewTemplateSectionItem(
        section.id,
        section.items.length === 0 ? AVOverviewItemTypeName.Intro : AVOverviewItemTypeName.Story,
        section.startTime,
        section.items.length,
      ),
    ]);
  };

  const handleClearItems = (index: number) => {
    setFieldValue(
      `sections.${index}.items`,
      section.items.map((i) => ({ ...i, summary: '' })),
    );
  };

  return (
    <styled.OverviewSection className="section">
      <EditBroadcastDetails
        index={index}
        editable={!section.sourceId && !section.otherSource && !section.seriesId}
      />
      <OverviewGrid index={index} />
      <Row className="buttons">
        <Row flex="1">
          <Button
            disabled={!section.name}
            variant={ButtonVariant.action}
            onClick={() => {
              handleAddItem(index);
            }}
          >
            New story <MdAdd className="icon" />
          </Button>
          <Button
            variant={ButtonVariant.danger}
            onClick={() => {
              handleClearItems(index);
            }}
            disabled={section.items.length === 0}
          >
            Clear all story text <MdClear className="icon" />
          </Button>
        </Row>
        <Button
          variant={ButtonVariant.danger}
          onClick={() => {
            handleDeleteSection(index);
          }}
          tooltip={
            section.items.length > 0 ? 'Delete all items before deleting section' : undefined
          }
          disabled={!(section.items.length === 0)}
        >
          Delete section
          <FaTrash className="delete" />
        </Button>
      </Row>
    </styled.OverviewSection>
  );
};
